/* eslint-disable perfectionist/sort-objects */
const isRequired = (field: string) => {
  return `${field} is required`;
};

const alreadyExists = (field: string) => {
  return `${field} already exists`;
};

const isPositive = (field: string) => {
  return `${field} must be a positive number`;
};

const notNegative = (field: string) => {
  return `${field} cannot be a negative number`;
};

const isValid = (value: string) => {
  return `Please enter a valid ${value}`;
};

const minLetters = (field: string, amount: number) => {
  return `${field} should have at least ${amount} letters`;
};

const atLeast = (amount: string, value: string) => {
  return `Please select at least ${amount} ${value}`;
};

const atMost = (amount: string, value: string) => {
  return `Please select at most ${amount} ${value}`;
};

const greaterThan = (field: string, amount: number) => {
  return `${field} must be greater than ${amount}`;
};

/* eslint perfectionist/sort-objects: "error" */
export const PAYMENT_METHOD_VALIDATION_MESSAGES = {
  paymentMethodTypeRequired: isRequired('Payment Method type'),
  premiumAmountMoreThanZero: greaterThan('Premium amount', 0),
  premiumAmountRequired: isRequired('Premium amount'),
  selfPayAmountRequired: isRequired('Self-pay amount'),
  selfPayAmountWhenCombined:
    'Self-pay amount must be greater than 0 when Payment Method type is Combined',
  selfPayAmountWhenSelfPay:
    'Self-pay amount must equal to Premium amount when Payment Method type is Self-pay',
  selfPayAmountWhenZorroPay:
    'Self-pay amount must be 0 when Payment Method type is Zorro Pay',
  zorroPayAmountRequired: isRequired('Zorro Pay amount'),
  zorroPayAmountWhenSelfPay:
    'Zorro Pay amount must be 0 when Payment Method Type is Self-pay',
  zorroPayAmountWhenZorroPayOrCombined:
    'Zorro Pay amount must be greater than 0 when Payment Method Type is Zorro Pay or Combined',
};

export const VALIDATION_MESSAGES = {
  accessLevelRequired: isRequired('Access level'),
  dateAgreementSignedRequired: isRequired('Date agreement signed'),
  accessLevelValid: isValid('Access level'),
  accidentalDeathAndDismembermentRequired: isRequired('AD&D'),
  accidentRequired: isRequired('Accident'),
  addressRequired: isRequired('Address'),
  agencyNameRequired: isRequired('Agency name'),
  agencyTypeRequired: isRequired('Agency type'),
  agencyTypeValid: isValid('Agency type'),
  ageRequired: isRequired('Age'),
  aleRequired: isRequired('ALE'),
  allowanceModelRequired: isRequired('Allowance model'),
  allowanceModelSourcePlanDesignRequired: isRequired('Plan design'),
  allowanceModelSourceNoteRequired: isRequired('Manual process description'),
  allowanceNotNegative: notNegative('Allowance'),
  allowanceRequired: isRequired('Allowance'),
  anticipatedCareLevelRequired: isRequired('Care level'),
  assignableAgenciesRequired: isRequired('Assignable agencies'),
  autoPaySetterRequired: 'Select who set up auto-pay',
  businessAddressRequired: isRequired('Business address'),
  businessEntityType: isRequired('Business entity type'),
  naicsCode: isRequired('NAICS code'),
  npnRequired: isRequired('Agency NPN'),
  npnValid: isValid('Agency NPN'),
  memberIdRequired: isRequired('Member ID'),
  medicareProviderRequired: isRequired('Medicare provider'),
  mainAgentNPNRequired: isRequired('Main agent NPN'),
  mainAgentFullNameRequired: isRequired('Main agent full name'),
  mainAgentNPNValid: isValid('Main agent NPN'),
  carrierRequired: isRequired('Carrier'),
  censusFileRequired: isRequired('Census file'),
  citizenshipStatus: isRequired('Citizenship status'),
  maritalStatus: isRequired('Marital status'),
  classRequired: isRequired('Class'),
  commissionCannotExceedTotal: 'Commission cannot exceed total fees',
  companyMailingAddress: isRequired('Company mailing address'),
  companyNameNoSpecialCharacters:
    'Company name cannot contain special characters',
  companyNameRequired: isRequired('Company name'),
  combinedPlanInfoRequired: isRequired('Combined plan info'),
  consultationLinkMax: 'Consultation link must not exceed ${max} characters',
  consultationLinkValid: isValid('consultation link'),
  countyRequired: isRequired('County'),
  countyDisambiguity:
    'Select the county matching the provided residential address',
  coverageStartDate: isRequired('Coverage start date'),
  earliestEnrollmentsSyncDate: isRequired('Earliest enrollments sync date'),
  criticalIllnessRequired: isRequired('Critical illness'),
  crmRecordIdValid: isValid('CRM record ID'),
  customClassCategoryLogicRequired: isRequired('Custom class category logic'),
  hasBeneficialOwnersRequired:
    'Please indicate whether any individual owns 25% or more of the business',
  beneficialOwnersRequired: atLeast('one', 'beneficial owner'),
  beneficialOwnersMax: atMost('4', 'beneficial owners'),
  dateOfBirthRequired: isRequired('Date of birth'),
  dateOfEventRequired: 'Date of event is a required field',
  dentalCareRequired: isRequired('Dental'),
  dependentMaxAgeValid: 'Dependent must be younger than 26',
  doctorsRequired: atLeast('one', 'doctor'),
  documentRequired: isRequired('Document'),
  documentUrlRequired: isRequired('Document url'),
  edgeCaseRequired: isRequired('Edge case'),
  effectiveDateRequired: isRequired('Effective date'),
  einRequired: isRequired('EIN'),
  eligibilityLogicRequired: isRequired('Eligibility logic'),
  eligibleFromRequired: isRequired('Eligibility start date'),
  eligibleFromValid: isValid('Eligibility start date'),
  emailAlreadyExists: alreadyExists('An account with this email address'),
  emailRequired: isRequired('Email'),
  emailsValid: 'Please enter valid emails',
  emailValid: isValid('email'),
  employeeAndChildrenRequired: isRequired(
    'Allowance for Employee and Children'
  ),
  employeeAndFamilyRequired: isRequired('Allowance for Employee and Family'),
  employeeAndSpouseRequired: isRequired('Allowance for Employee and Spouse'),
  employeeID: isRequired('Employee id'),
  employeeMaxAgeValid: 'Employee must be younger than 120',
  employeeMinAgeValid: 'Employee must be older than 18',
  employeeMonthlyContributionNotNegative: notNegative('Employee contribution'),
  employeeMonthlyContributionRequired: isRequired('Employee contribution'),
  employeeOnlyRequired: isRequired('Allowance for Employee'),
  employerMonthlyContribution: isRequired('Employer monthly contribution'),
  employerMonthlyContributionNotNegative: notNegative('Employer contribution'),
  employerMonthlyContributionRequired: isRequired('Employer contribution'),
  employerRequired: isRequired('Employer'),
  employmentTypeRequired: isRequired('Employment type'),
  wageTypeRequired: isRequired('Wage type'),
  customClassCategoryRequired: isRequired('Custom class category'),
  electionWindowRequired: isRequired('Election window'),
  enrollmentStatusRequired: isRequired('Status'),
  enrollmentTeamRequired: isRequired('Enrollment team'),
  enrollmentTypeRequired: isRequired('Enrollment type'),
  estimatedEmployeesRequired: isRequired('Estimated employees'),
  estimatedEmployeesMin: greaterThan('Estimated employees', 0),
  estimatedParticipationRateRequired: isRequired(
    'Estimated participation rate'
  ),
  estimatedParticipationRateMax:
    'Estimated participation rate must not exceed ${max}%',
  estimatedParticipationRateMin: greaterThan('Estimated participation rate', 0),
  excludeAffordability: isRequired('Exclude affordability'),
  exerciseRequired: isRequired('Exercise'),
  expectedStartOfCoverageRequired: isRequired('Expected start of coverage'),
  externalIDRequired: isRequired('Plan id'),
  facilityRequired: atLeast('one', 'facility'),
  familyHistoryRequired: isRequired('Family history'),
  familyUnitRequired: isRequired('Family Unit'),
  fileNameAlreadyExists: alreadyExists('File name'),
  fileNameCannotEndWithExtension: "The name can't end with a file extension",
  fileNameRequired: isRequired('File name'),
  firstNameMinTwoLetters: minLetters('First name', 2),
  firstNameRequired: isRequired('First name'),
  fixedPlatformFee: isRequired('Fixed platform fee'),
  fullTimeEligibilityLogicRequired: isRequired('Full time eligibility logic'),
  genderRequired: isRequired('Gender'),
  hasAutoPayBeenSetUp: 'Confirm if auto-pay has been set up',
  hasNoPaymentDocumentRequired: isRequired('Has no payment document'),
  hireDateRequired: isRequired('Hire date'),
  hireDateValid: isValid('Hire date'),
  hrisProviderNotListedTextRequired: isRequired('HRIS / payroll system name'),
  hospitalIndemnityRequired: isRequired('Hospital indemnity'),
  hourlyEligibilityLogicRequired: isRequired('Hourly eligibility logic'),
  initialDrawAmountRequired: isRequired('Initial draw amount'),
  initialDrawAmountPositive: isPositive('Initial draw amount'),
  initialDrawDateRequired: isRequired('Initial draw date'),
  initialDrawDateMustBeBusinessDay: 'Initial draw date must be a business day',
  initialDrawDateMustBeFuture: 'Initial draw date must be a future date',
  reserveAmountRequired: isRequired('Reserve amount'),
  reserveAmountPositive: isPositive('Reserve amount'),
  thresholdAmountRequired: isRequired('Threshold amount'),
  thresholdAmountPositive: isPositive('Threshold amount'),
  thresholdAmountMustBeLessThanReserve:
    'Threshold amount must be less than reserve amount',
  isAdminRequired: isValid('Make a Zorro admin'),
  isCombinedPlanRequired: isRequired('Combined plan'),
  isLegalNameSameAsCompanyName: isRequired(
    'Legal name is the same as company name'
  ),
  isMailingAddressSameAsHQAddress: isRequired(
    'Mailing address is the same as HQ address'
  ),
  isMailingAddressSameAsResidentialAddress: isRequired(
    'Mailing address is the same as Residential address'
  ),
  ITINRequired: isRequired('ITIN'),
  lastDateOfBenefitEligibilityRequired: isRequired(
    'Last date of benefit eligibility'
  ),
  lastDateOfEmploymentRequired: isRequired('Last date of employment'),
  lastNameMinTwoLetters: minLetters('Last name', 2),
  lastNameRequired: isRequired('Last name'),
  legalNameRequired: isRequired('Legal name'),
  lifeInsuranceRequired: isRequired('Life insurance'),
  logoUrlRequired: isRequired('Logo url'),
  lossOfAbilityToWorkRequired: isRequired('Ability to work'),
  mailingAddressRequired: isRequired('Mailing address'),
  medicationRequired: atLeast('one', 'medication'),
  monthlySEPDeadlineRequired: isRequired('Monthly SEP deadline'),
  nonDependentMaxAgeValid: 'Non-dependent must be younger than 120',
  nonDependentMinAgeValid: 'Non-dependent must be older than 18',
  notesRequired: isRequired('Notes'),
  oepDateRequired: isRequired('OEP date'),
  optionValid: isValid('option'),
  partTimeEligibilityLogicRequired: isRequired('Part time eligibility logic'),
  paymentHandlerRequired: 'Select who handled the payment',
  paymentMethodRequired: isRequired('Payment method'),
  payrollCycleRequired: isRequired('Payroll cycle'),
  pepmFee: isRequired('PEPM fee'),
  planTypeRequired: isRequired('Plan type'),
  personalEmailRequired: isRequired('Personal email'),
  personalEmailValid: isValid('email'),
  phoneNumberRequired: isRequired('Phone number'),
  phoneNumberValid: isValid('US phone number'),
  planDetailsCarrier: isRequired('Carrier'),
  planDetailsDeductible: isRequired('Individual deductible'),
  planDetailsMaxOutOfPocket: isRequired('Individual max out of pocket'),
  earlyEnrollmentsOffset: isRequired('Early enrollments offset'),
  planDetailsNetworkType: isRequired('Network type'),
  planDetailsPlanName: isRequired('Plan name'),
  planMarketRequired: isRequired('Plan market'),
  planNameRequired: isRequired('Plan name'),
  plansDetailsDeductibleNotNegative: notNegative('Individual deductible'),
  plansDetailsMoopNotNegative: notNegative('Individual Max out of pocket'),
  planYearRequired: isRequired('Plan year'),
  pregnantRequired: isRequired('Pregnant'),
  premiumPositive: isPositive('Premium'),
  premiumRequired: isRequired('Premium'),
  producerRequired: isRequired('Producer'),
  qleDateRequired: isRequired('Event date'),
  qleTypeRequired: isRequired('Type of life event'),
  quoteNameRequired: isRequired('Quote name'),
  quoteYearRequired: isRequired('Quote year'),
  relationshipRequired: isRequired('Relationship'),
  residentialAddressInvalid:
    "Your address couldn't be verified. Try choosing it from the search results.",
  residentialAddressRequired: isRequired('Residential address'),
  roleRequired: isRequired('Role'),
  rosterFileRequired: isRequired('Roster file'),
  isAORChanged: isRequired('AOR change'),
  salaryEligibilityLogicRequired: isRequired('Salary eligibility logic'),
  selfPayPositive: isPositive('Self pay'),
  selfPayRequired: isRequired('Self pay'),
  selfReportTypeRequired: isRequired('Self report type'),
  sendInvitationRequired: isRequired('Send invitation'),
  sendInvitationValid: isValid('Send invitation'),
  shouldSendEnrollmentConfirmationEmailRequired: isRequired(
    'Send enrollment confirmation email'
  ),
  shouldSendEnrollmentConfirmationEmailValid: isValid(
    'Send enrollment confirmation email'
  ),
  enrollmentTeamResponsibilitiesMax:
    'Enrollment team responsibilities must not exceed ${max} characters',
  signedAgreementRequired: isRequired('Signed agreement'),
  smokerRequired: isRequired('Smoker'),
  enforcePostTaxDeductions: isRequired('Enforce post tax deductions'),
  sportsRequired: isRequired('Sports'),
  ssnNumberValid: isValid('Social Security Number'),
  ssnRequired: isRequired('Social Security Number'),
  stateOfIncorporationRequired: isRequired('State of incorporation'),
  supplementalTypeRequired: isRequired('Supplemental type'),
  taxIdTypeRequired: isRequired('EIN/ITIN type'),
  validNumber: isValid('number'),
  visionCareRequired: isRequired('Vision'),
  waitingPeriodRequired: isRequired('Waiting period'),
  waiveRequired: isRequired('Waive'),
  wasPaymentCompletedRequired: 'Confirm if the payment was completed',
  websiteUrlMax: 'Website URL must not exceed ${max} characters',
  websiteUrlValid: isValid('website URL'),
  whoIsEnrolledRequired: isRequired('Who is enrolled'),
  yearlySalaryRequired: isRequired('Yearly salary'),
  yearlySalaryValid: isValid('Yearly salary'),
  yearsInBusinessMin: greaterThan('Years in business', 0),
  yearsInBusinessRequired: isRequired('Years in business'),
  zipCodeOnlyFiveDigits: 'Zip code must have 5 digits',
  zipCodeRequired: isRequired('Zip code'),
  zorroPartnerRequired: isRequired('Zorro partner'),
  reportModeRequired: isRequired('Report mode'),
  payPeriodStartDateRequired: isRequired('Pay period start date'),
  payPeriodEndDateRequired: isRequired('Pay period end date'),
  indicateChangesSinceRequired: isRequired('Indicate changes since'),
};
